module.exports = __webpack_public_path__ + "static/media/iconInfoActive.22a7b919.svg";